import { render, staticRenderFns } from "./ModalBollettiniAssociati.vue?vue&type=template&id=4c2e0aa7"
import script from "./ModalBollettiniAssociati.vue?vue&type=script&lang=js"
export * from "./ModalBollettiniAssociati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports